// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"U5-z"};